import {
  deleteAction,
  patch,
  post,
  postFormData,
  get,
  put,
  paginatedAll,
  getBinaryFileStream,
  postEncodedData,
  paginatedEncodedAll,
} from './utils';

const dao = {
  getBrandIdAndTemplate: formData =>
    postFormData('/smb/skincare/get-brand-id-and-template.action', formData),
  migrateTemplateV2: formData =>
    postFormData('/api/template/migrate-smb-v2.action', formData),
  getTemplateLayout: formData =>
    postFormData('/api/template/get-template-layout.action', formData),
  getTemplate: formData =>
    postFormData('/api/template/get-template.action', formData),
  getTemplateDefaultConfig: formData =>
    postFormData('/smb/skincare/get-template-default-config.action', formData),
  getScoreFormat: () =>
    get(`/api/v2/skincare-pro/ui-configuration/score-format`),
  updateTemplate: formData =>
    postFormData(' /api/template/update-template.action', formData),
  uploadFile: formData =>
    postFormData(`/api/file/upload-file.action`, formData),
  uploadFileV2: formData => postFormData(`/api/v2/files`, formData),
  publishBrandId: formData =>
    postFormData('/smb/skincare/publish-brand-id.action', formData),
  getOverview: formData =>
    postFormData('/smb/skincareProInsight/get-overview.action', formData),
  getImpression: formData =>
    postFormData('/smb/skincareProInsight/get-impression.action', formData),
  getDiagnostic: formData =>
    postFormData('/smb/skincareProInsight/get-diagnostic.action', formData),
  getGetReport: formData =>
    postFormData('/smb/skincareProInsight/get-get-report.action', formData),
  getSessionStart: formData =>
    postFormData('/smb/skincareProInsight/get-session-start.action', formData),
  //report
  getReportPatients: params =>
    get(`/api/v2/service/scp/report/patients`, params),
  getReportPatientsOverview: params =>
    get(`/api/v2/service/scp/report/patients/overview`, params),
  getDiagnostics: params =>
    get(`/api/v2/service/scp/report/diagnostics`, params),
  getDiagnosticsOverview: () =>
    get(`/api/v2/service/scp/report/diagnostics/overview`),
  getReportAllPatients: params =>
    get(`/api/v2/service/scp/report/all-patients`, params),
  getReportAllPatientsOverview: () =>
    get(`/api/v2/service/scp/report/all-patients/overview`),
  getReportDemographic: params =>
    get(`/api/v2/service/scp/report/demographics`, params),
  getReportDemographicOverview: () =>
    get(`/api/v2/service/scp/report/demographics/overview`),
  getSkinScores: params =>
    get(`/api/v2/service/scp/report/skin-concern-scores`, params),
  getSkinScoresOverview: () =>
    get(`/api/v2/service/scp/report/skin-concern-scores/overview`),
  getGenericList: formData =>
    postFormData('/api/generic-product/list.action', formData),
  deleteGenericList: formData =>
    postFormData('/api/generic-product/delete.action', formData),
  createGenericList: formData =>
    postFormData('/api/generic-product/create.action', formData),
  updateGenericList: formData =>
    postFormData('/api/generic-product/update.action', formData),
  copyGenericList: formData =>
    postFormData('/api/generic-product/save-as.action', formData),
  getGenericInfo: formData =>
    postFormData('/api/generic-product/get-info.action', formData),
  getProductCount: formData =>
    postFormData('/smb/skincare/get-product-count.action', formData),
  getCategoryList: formData =>
    postFormData('/api/generic-product-category/list.action', formData),
  createCategoryList: formData =>
    postFormData('/api/generic-product-category/create.action', formData),
  updateCategoryList: formData =>
    postFormData('/api/generic-product-category/update.action', formData),
  deleteCategoryList: formData =>
    postFormData('/api/generic-product-category/delete.action', formData),
  publishSkincare: formData =>
    postFormData('/smb/skincare/publish-skincare.action', formData),
  getSetting: params =>
    post('/api/recommendation/query-setting.action', params),
  getSettingDisplayOrder: params =>
    post(
      '/api/v2/skincare/recommend-rule-based/product-order/generate',
      params
    ),
  createSetting: params =>
    post('/api/recommendation/create-setting.action', params),
  updateSetting: params =>
    post('/api/recommendation/update-setting.action', params),
  publishRecommendation: params =>
    postFormData('/smb/skincare/publish-recommendation.action', params),
  getRecommendation: id => get(`/api/v2/skincare/recommend/${id}`),
  getProductOrderByMode: params =>
    post('/api/v2/skincare/recommend/product-order/generate', params),
  getRecommendationList: params => get('/api/v2/skincare/recommend', params),
  deleteRecommendation: id => deleteAction(`/api/v2/skincare/recommend/`, id),
  copyRecommendation: id => post(`/api/v2/skincare/recommend/${id}/copy`),
  createRecommendation: params => post('/api/v2/skincare/recommend', params),
  updateRecommendation: (id, params) =>
    put(`/api/v2/skincare/recommend/${id}`, params),
  getAiRuleQuotaStatus: () =>
    get(` /api/v2/skincare/recommend/ai-rule-quota-status`),
  syncRecommendationProducts: id =>
    post(`/api/v2/skincare/recommend/${id}/sync-products`),
  getAiRecommendationRuleStatus: () =>
    get('/api/v2/skincare/recommend/ai-rule-quota-status'),
  getRecommendPublishSettings: () =>
    get('/api/v2/skincare/recommend/publishing-settings'),
  updateRecommendPublishSettings: params =>
    put('/api/v2/skincare/recommend/publishing-settings', params),
  //CRM APIs:
  //Store
  createStore: params => post('/api/v2/stores', params),
  getStores: params => get('/api/v2/stores', params),
  getAllStores: params => paginatedAll('/api/v2/stores', params),
  getStore: id => get(`/api/v2/stores/${id}`),
  updateStore: (id, params) => put(`/api/v2/stores/${id}`, params),
  updateStorePartially: (id, params) => patch(`/api/v2/stores/${id}`, params),
  deleteStore: id => deleteAction(`/api/v2/stores`, id),
  copyStore: id => post(`/api/v2/stores/${id}/copy`),
  getStoresOrder: () => get('/api/v2/stores/order'),
  updateStoresOrder: params => post('/api/v2/stores/order', params),
  //Patient
  getPatients: params => get('/api/v2/crm/patients', params),
  getPatient: id => get(`/api/v2/crm/patients/${id}`),
  createPatient: params => post('/api/v2/crm/patients', params),
  updatePatient: params => put(`/api/v2/crm/patients/${params.id}`, params),
  updatePatientPartially: params =>
    patch(`/api/v2/crm/patients/${params.id}`, params),
  deletePatient: id => deleteAction(`/api/v2/crm/patients`, id),
  //CRM report
  getPatientReports: params =>
    paginatedAll(`/api/v2/crm/patients/${params.patientId}/reports`, {
      asc: params.asc,
      solution_type: params.solutionType,
    }),
  getPatientReportByUuid: params =>
    get(`/api/v2/crm/patients/${params.patientId}/reports/${params.uuid}`),
  deletePatientReport: (patientId, reportId) =>
    deleteAction(`/api/v2/crm/patients/${patientId}/reports`, reportId),
  getPatientReportStatus: params =>
    get('/api/v2/crm/patients/report-status', params),
  batchImportPatient: params =>
    postFormData('/api/v2/crm/patients/batch-import', params),
  exportPatient: () => getBinaryFileStream('/api/v2/crm/patients/export'),
  createNotes: params =>
    post(`/api/v2/crm/patients/${params.patientId}/notes`, params.notes),
  getNotes: id =>
    post(`/smb-backend/skincarepro/console/list-notes.action`, {patientId: id}),
  deleteNotes: (patientId, noteId) =>
    deleteAction(`/api/v2/crm/patients/${patientId}/notes`, noteId),
  updateNotes: params =>
    put(
      `/api/v2/crm/patients/${params.patientId}/notes/${params.notes.noteId}`,
      {note: params.notes.note}
    ),
  sendReportMail: params =>
    post(
      `/api/v2/crm/patients/${params.patientId}/reports/${
        params.consoleUUID
      }/send`,
      {email: params.email}
    ),
  getSaasApis: params => get('/api/v2/s2s/api-keys', params),
  createSaasApi: params => post('/api/v2/s2s/api-keys', params),
  deleteSaasApi: id => deleteAction(`/api/v2/s2s/api-keys`, id),
  updateSaasApi: params => put(`/api/v2/s2s/api-keys/${params.id}`, params),
  getSaasApiDoc: () => get('/api/v2/s2s/doc/smb'),
  getEnabledHd: () => post('/api/v2/skincare-pro/recommendation/enable-hd'),
  getDetectionFeatures: () =>
    get(
      '/api/v2/skincare-pro/ui-configuration/skincare-detection/detection-features'
    ),
  getEmailTemplate: params => get('/api/v2/customer/setting/default', params),
  getCustomerSetting: params => get('/api/v2/customer/setting', params),
  putCustomerSetting: params => put('/api/v2/customer/setting', params),
  publishCustomerSetting: params =>
    post('/api/v2/customer/setting/publish', params),
  previewCustomerSetting: params =>
    post('/api/v2/customer/setting/preview', params),
  getSurveyFormSetting: params =>
    get('/api/v2/skincare/survey/publishing-settings', params),
  getSurveyLinkedToRecommend: params =>
    postEncodedData(
      '/api/survey/list-recommendation-setting-usage.action',
      params
    ),
  publishSurveyFormSetting: params =>
    put('/api/v2/skincare/survey/publishing-settings', params),
  listSurveyForms: params =>
    paginatedEncodedAll('/api/survey/list.action', params),
  getSurveyFormTemplate: params =>
    get('/smb/skincare/get-template-default-config.action', params),
  getSurveyForm: params =>
    postEncodedData('/api/survey/get-info.action', params),
  createSurveyForm: params =>
    postEncodedData('/api/survey/create.action', params),
  updateSurveyForm: params =>
    postEncodedData('/api/survey/update.action', params),
  copySurveyForm: params => postEncodedData('/api/survey/copy.action', params),
  deleteSurveyForm: params =>
    postEncodedData('/api/survey/delete.action', params),
  validateJs: params => post('/api/recommendation/validate-js.action', params),
  listCustomizationRequests: params => get('/api/v2/template-requests', params),
  getCustomizationRequest: id => get(`/api/v2/template-requests/${id}`),
  getCustomizationRequestByS2s: params =>
    post(`/smb-backend/epf/msr-template-requests.action`, params),
  createCustomizationRequest: params =>
    post(`/api/v2/template-requests`, params),
  updateCustomizationRequest: params =>
    put(`/api/v2/template-requests/${params.id}`, params),
  submitMsrRequest: id => post(`/api/v2/template-requests/${id}/submit`),
  //template
  listUIConfigTemplates: params => get('/api/v2/template', params),
  selectUIConfigTemplate: params =>
    post(`/api/v2/template/${params.template_id}/select`, params),
};

export default dao;
